import { LenderName, PaymentMethodType, ProcessingLenderStrategyType } from '@nemuru-eng/js-api-client';
import { ChooseStrategyType } from '@nemuru-eng/js-api-client/slim';

import { MerchantOrchestrationMap } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/maps/merchantOrchestration.map';
import { OrchestrationLabelsMap } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/maps/orchestrationLabels.map';
import { OrchestrationConfig } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/OrchestrationConfig';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { LenderIconAvatar } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { TableCellValue } from '@/components/shared/components/TableCellValue';
import { Text } from '@/components/shared/components/Text';
import { StatusTagType } from '@/config/types';

interface OrchestrationConfigCellsProps {
  paymentMethodType: PaymentMethodType;
  config: OrchestrationConfig;
}

export const OrchestrationConfigCells = ({ paymentMethodType, config }: OrchestrationConfigCellsProps) => {
  const isParallel = config.processingStrategy === ProcessingLenderStrategyType.PARALLEL;
  const lenderName = config.chooseStrategyTypeOptions?.lenderName;
  const notApplicable = <Font color="textSecondary">—</Font>;

  return (
    <>
      <TableCellValue value={<Text tId={OrchestrationLabelsMap.strategy(config.processingStrategy)} />} />
      <TableCellValue
        value={isParallel ? notApplicable : <Text tId={OrchestrationLabelsMap.mode(config.processingMode)} />}
      />
      <TableCellValue
        value={isParallel ? notApplicable : <Text tId={OrchestrationLabelsMap.stopCondition(config.stopCondition)} />}
      />
      <TableCellValue
        value={
          <FlexRow justifyContent="flex-start" gridGap={8} flexWrap="wrap">
            {config.chooseStrategyType === ChooseStrategyType.PRIORITY_LENDER_THEN_PRICE && lenderName ? (
              <>
                <Text tId="LENDER_ORCHESTRATION_PRIORITY_LENDER_CELL" />
                <LenderIconAvatar size="small" lenderName={lenderName as LenderName} />
                <Text tId={lenderName} />
              </>
            ) : (
              <Text tId={OrchestrationLabelsMap.chooseStrategy(config.chooseStrategyType)} />
            )}
            {MerchantOrchestrationMap.isDefault(paymentMethodType, config) && (
              <StatusTag type={StatusTagType.DEFAULT} labelTextId="LENDER_ORCHESTRATION_DEFAULT_TAG" size="small" />
            )}
          </FlexRow>
        }
      />
    </>
  );
};
